import { render, staticRenderFns } from "./MyTasksCard.vue?vue&type=template&id=3b1667c2&scoped=true"
import script from "./MyTasksCard.vue?vue&type=script&lang=js"
export * from "./MyTasksCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1667c2",
  null
  
)

export default component.exports